/**
 * Size of the mnemonic catalog, rounded DOWN so the claim is never an overstatement.
 *
 * Measured from the built content database: 1,132 meaning mnemonics plus 4,477 pronunciation
 * mnemonics. Rounding down to 1,000 keeps the copy honest as content is authored, and means this
 * constant only ever needs revisiting to make the number bigger.
 */
export const MNEMONIC_CATALOG_SIZE_LABEL = "1,000";

/** Shown under a free mnemonic once a signed-out viewer reveals it. */
export function buildRevealedMnemonicUpsell(): string {
  return `Create an account to save and access ${MNEMONIC_CATALOG_SIZE_LABEL}+ mnemonics just like this one`;
}

/** Shown in place of a premium mnemonic for a viewer who cannot read it. */
export function buildPremiumLockedPrompt(grapheme: string): string {
  return `Sign in to view a mnemonic for ${grapheme} and ${MNEMONIC_CATALOG_SIZE_LABEL}+ other characters`;
}

/** Shown when no mnemonic exists for this grapheme yet. */
export function buildAbsentMnemonicPrompt(grapheme: string): string {
  return `Sign in to create your own mnemonic for ${grapheme}`;
}
